const CONFIGS = [
	{"code":"001","name":"药品类型","parentId":0},
	{"code":"002","name":"药品剂型","parentId":0},
	{"code":"003","name":"医保等级","parentId":0},
	{"code":"004","name":"开药控制","parentId":0},
	{"code":"005","name":"药理分类","parentId":0},
	{"code":"006","name":"药物分类","parentId":0},
	{"code":"007","name":"物资类型","parentId":0},
	{"code":"008","name":"默认用药途径","parentId":0},
	{"code":"009","name":"默认用药时间","parentId":0},
	{"code":"010","name":"费用类别","parentId":0},
	{"code":"011","name":"耗材种类","parentId":0},
	// {"code":"012","name":"规格型号","parentId":0},
	{"code":"013","name":"生产厂家","parentId":0},
	{"code":"014","name":"收款方式","parentId":0},
	{"code":"015","name":"医保类型","parentId":0},
	{"code":"016","name":"证件类型","parentId":0},
	{"code":"017","name":"患者类型","parentId":0},
	// {"code":"018","name":"挂号类型","parentId":0},
	{"code":"019","name":"医疗类别","parentId":0},
	{"code":"020","name":"部门类型","parentId":0},
	{"code":"021","name":"人员类型","parentId":0},
	{"code":"022","name":"统计分类","parentId":0},
	{"code":"023","name":"费用类型","parentId":0},
	{"code":"024","name":"病区属性","parentId":0},
	{"code":"025","name":"透析模式","parentId":0},
	{"code":"026","name":"抗凝方式","parentId":0},
	{"code":"027","name":"透析频率","parentId":0},
	{"code":"029","name":"报损原因","parentId":0},
	{"code":"030","name":"医疗文书类型","parentId":0},
	{"code":"031","name":"医护排班","parentId":0},
	{"code":"032","name":"文书类型","parentId":0},
	{"code":"033","name":"频次","parentId":0},
	{"code":"034","name":"通路类型","parentId":0},
	{"code":"035","name":"传染病标识","parentId":0},
]
export default CONFIGS



//////////////////
// WEBPACK FOOTER
// ./public/configInit.js
// module id = null
// module chunks = 